module.exports = __webpack_public_path__ + "img/ИФ-1(А)-011-m.3429ef01.png";